"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numericEnumEntries = void 0;
/**
 * Returns the entries of a numeric TypeScript enum as an array of label/value pairs,
 * filtering out the reverse-mapping entries that the TypeScript compiler generates.
 *
 * @param e - The numeric enum object.
 * @returns An array of `{ label, value }` pairs sorted by enum value.
 *
 * @example
 * numericEnumEntries(PowerQualityIssue)
 * // [{ label: "None", value: 1 }, { label: "Unspecified", value: 2 }, ...]
 */
function numericEnumEntries(e) {
    return Object.entries(e)
        .filter(([, v]) => typeof v === "number")
        .map(([label, value]) => ({ label, value: value }));
}
exports.numericEnumEntries = numericEnumEntries;
